import React from 'react';
import PropTypes from 'prop-types';
import styles from './NewsHeaderSection.pcss';

export default class NewsHeaderSection extends React.Component {
    static propTypes = {
        sectionData: PropTypes.object
    };
    static defaultProps = {
        sectionData: {}
    };

    render() {
        const {backgroundImage, description} = this.props.sectionData;
        const style = {};
        if (backgroundImage) {
            style.backgroundImage = `url("${backgroundImage}")`;
        }
        const content = description || '';
        return (
            <div className={styles.section} style={style}>
                <span className={styles.title}>Get an edge</span>
                <div className={styles.content}>
                    <div dangerouslySetInnerHTML={{__html: content}} />
                </div>
            </div>
        );
    }
}
